import { StyleSheet } from "react-native";
import { theme } from "@lookiero/sty-psp-ui";

const style = () => {
  const { colorBgBase, space4, space6 } = theme();

  return StyleSheet.create({
    title: {
      backgroundColor: colorBgBase,
      paddingBottom: space4,
      paddingHorizontal: space6,
      paddingTop: space6,
    },
  });
};

export { style };
